import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { BlogService } from '../blog-group/blog.service';
import { BooksService } from '../book-group/books.service';
import { AuthorsService } from '../author-group/authors.service';
import { EventsService } from '../event-group/events.service';
import { StatsService } from '../stats-group/stats.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {

  constructor(public authService: AuthService, public authorService: AuthorsService, public bookService: BooksService, public blogService: BlogService, public eventService: EventsService, public statsService: StatsService) { }


  signOut() {
    this.authService.signOut()
  }

}
